// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Import Firestore
import { getStorage } from "firebase/storage"; // Import Storage
import { getAuth } from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyChji-c-AxPBwRgGcLyicxOU3_ferYi_2c",
  authDomain: "theastech-50e7e.firebaseapp.com",
  projectId: "theastech-50e7e",
  storageBucket: "theastech-50e7e.appspot.com",
  messagingSenderId: "843694923605",
  appId: "1:843694923605:web:dffb56449debd61b8d59dc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const storage = getStorage(app); // Initialize Firebase Storage
const auth = getAuth(app);

export { db, storage, auth };
